// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-button__btn {
  color: var(--share-button-text-color);
  background-color: var(--share-button-bg-color);
  border-color: var(--share-button-border-color);
}
.share-button__btn:hover {
  color: var(--share-button-text-color-hover);
  background-color: var(--share-button-bg-color-hover);
  border-color: var(--share-button-border-color-hover);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Share/Share.scss"],"names":[],"mappings":"AACI;EACI,qCAAA;EACA,8CAAA;EACA,8CAAA;AAAR;AAEQ;EACI,2CAAA;EACA,oDAAA;EACA,oDAAA;AAAZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
